import type { TagTypeGroupResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetTagTypeGroupsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetTagTypeGroupsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetTagTypeGroups = createQueryHook<
  Record<string, never>,
  TagTypeGroupResponseRow[],
  GetTagTypeGroupsQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.tag.allTypeGroups.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ tag_type_group: data }),
  graphqlDocument: GetTagTypeGroupsDocument,
});
